import Panel from 'portaltransparencia-common/components/Panel.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';

import ResultadoPesquisa from '../pesquisa/ResultadoPesquisa.react.js';
import AtalhosGeraisForm from './AtalhosGeraisForm.react.js';

export class HotKeys extends Component {
  static propTypes = {
    menu: PropTypes.object.isRequired
  };

  render() {
    const { menu } = this.props;

    return (
      <section>
        <h1 className="text-title center mb-xs">Teclas de Atalho</h1>

        <Panel expansible={false}>
          <AtalhosGeraisForm className="mb-xs" />
          <ResultadoPesquisa list={menu} valorPesquisado="" />
        </Panel>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    menu: state.menu.get('menu')
  };
}

export default connect(mapStateToProps)(HotKeys);
